<div role="main" class="main">
	<section class="page-header page-header-modern bg-color-light-scale-1 page-header-md">
		<div class="container">
			<div class="row">
				<div class="col-md-12 align-self-center p-static order-2 text-center">
					<h1 class="text-dark font-weight-bold text-8" style="color:white !important">{{blog.title}}</h1>
				</div>
			</div>
		</div>
	</section>
	<div class="container py-4">
		<div class="row">
			<div class="col">
				<div class="blog-posts single-post" >
					<article class="post post-large blog-single-post border-0 m-0 p-0" style="margin:0">
						<div class="post-image ml-0" style="margin:0px">
							<a href="javascript:void(0)">
								<img [src]="apiurl+blog.photo"  class="img-fluid img-thumbnail img-thumbnail-no-borders rounded-0 mainimg" alt="{{blog.title}}" />
							</a>
						</div>

						<div class="post-content ml-0" style="padding-left: 3%;">
							<h2 class="font-weight-bold">
								<a href="javascript:void(0)">{{blog.title}}</a>
							</h2>
							<div class="post-meta">
                <span>
                  <i class="fa fa-calendar"></i> {{blog.dt | date:'dd.MM.yyyy'}}
                </span>
								<span>
									<i class="fa fa-user"></i> Yazar
									<a >{{blog.creator}}</a>
								</span>

							</div>
              <div class="col-md-12" [innerHTML]="body"></div>
                </div>
              </article>
            </div>
      </div>
    </div>
  </div>
</div>
